module.exports = __webpack_public_path__ + "assets/img/btn-view-info-hover-4f0c56a8.png";